import { FlexContainer, Inputs, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { useTranslation } from 'Hooks/useTranslation';
import { CommentComponentProps } from './types';
import * as Styled from './styles';

const CommentComponent = ({ comment, onClick }: CommentComponentProps): JSX.Element => {
  const { t } = useTranslation(locizeNS.MODALS);
  return (
    <FlexContainer direction="column" align="center" fullWidth gap="dimension_16">
      <Text type="paragraphs" size="M_L_L" color="dark" align="center">
        {t('Declaration.received.comment')}
      </Text>
      <Text type="paragraphs" size="XS_M_S" color="grey" align="center">
        {t('Declaration.received.comment.subtitle')}
      </Text>
      <Styled.TextAreaContainer fullWidth justify="center">
        <Inputs.TextArea
          value={comment}
          placeholder={t('Declaration.write.comment')}
          onChange={val => onClick(val)}
        />
      </Styled.TextAreaContainer>
    </FlexContainer>
  );
};

export default CommentComponent;
